<template>
  <div class="fill-height pa-0 ma-0" style="background-color:#f5f5f5" fluid>
    <v-dialog max-width="400" v-model="newClusterDialog">
      <v-card flat>
        <v-card-title>Create a new Cluster
          <div class="flex-grow-1"></div> <v-btn icon @click="newClusterDialog = !newClusterDialog"><v-icon
              medium>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-text-field v-model="newClusterName" solo-inverted hide-details flat label="New cluster name..."
          class="pa-5"></v-text-field>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="danger" text @click="postCluster(), newClusterDialog = !newClusterDialog">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-content>
      <v-row justify="center" class="px-0 py-3">
        <v-card color="#f5f5f5" flat width="95%" class="mx-auto">
          <p style="text-align:center;" class="pt-6 display-1 font-weight-medium">
            <span v-if="entityType == 'supplier'">Supplier Clusters</span>
            <span v-else>Buyer Clusters</span>
          </p>
          <p style="text-align:center;" class="body-1 font-weight-normal">
            Use Clusters to build a single view of multiple related supplier or buyer entities. Common examples include
            competitors, subsidiaries, government regions or verticals, and business partners.
          </p>

          <v-card flat>
            <v-data-table :headers="headers" :items="filteredClusters" item-selected-class="" :footer-props="{
              'items-per-page-options': [100]
            }" :items-per-page="100" :loading="loading" class="elevation-1 py-2">
              <template v-slot:top>
                <v-card-title>
                  <v-text-field prepend-inner-icon="mdi-magnify" v-model="search" dense single-line outlined
                    hide-details clearable flat label="Search" class="pr-3 py-3"></v-text-field>
                  <v-btn outlined @click="newClusterDialog = true"><v-icon>mdi-plus</v-icon> Cluster</v-btn>
                </v-card-title>
              </template>
              <template v-slot:item.name="{ item }">
                <v-list-item-content @click="fetchClusterData(item.id)">
                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                  <!-- <v-list-item-subtitle v-if="item.search_query">
                        {{ JSON.parse(item.search_query)[entityIDType].length }} entities
                      </v-list-item-subtitle> -->
                </v-list-item-content>
              </template>
              <template v-slot:item.entity_count="{ item }">
                <span v-if="item.search_query">{{ JSON.parse(item.search_query)[entityIDType].length }}</span>
              </template>
              <template v-slot:item.id="{ item }">
                <div>
                  <v-tooltip top dark color="#000000" style="opacity: 0.7;">
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" icon target="_blank" color="secondary" light
                        style="text-decoration: none !important;" @click="fetchClusterData(item.id)">
                        <v-icon>mdi-format-list-bulleted</v-icon>
                      </v-btn>
                    </template>
                    <span>View all {{ item.name }} notices</span>
                  </v-tooltip>

                  <v-tooltip top dark color="#000000" style="opacity: 0.7;">
                    <template v-slot:activator="{ on }">
                      <v-btn right color="secondary" icon target="_blank" :to="'/cluster/' + item.id" v-on="on">
                        <v-icon medium color="secondary">mdi-open-in-new</v-icon>
                      </v-btn>
                    </template>
                    <span>View / Edit {{ item.name }} Cluster Profile</span>
                  </v-tooltip>

                  <v-tooltip top dark color="#000000" style="opacity: 0.7;">
                    <template v-slot:activator="{ on }">
                      <v-btn right icon @click="selectedItem = item, delete_cluster = true" v-on="on">
                        <v-icon medium color="primary">mdi-delete</v-icon>
                      </v-btn>
                    </template>
                    <span>Delete {{ item.name }} Cluster</span>
                  </v-tooltip>
                </div>
              </template>
            </v-data-table>
          </v-card>
        </v-card>
      </v-row>
    </v-content>
    <v-dialog v-model="delete_cluster" max-width="400" absolute>
      <v-card>
        <p class="font-weight-bold mx-auto pa-6">
          <span class="text-body-1">Delete Cluster: </span>
          <span v-if="selectedItem"> {{ selectedItem["name"] }}</span><span class="text-body-1">?</span>
        </p>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" text @click="delete_cluster = false">
            Cancel
          </v-btn>

          <v-btn color="primary" text @click="(delete_cluster = false), removeCluster(selectedItem.id)">
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { getClusters, updateClusters, addCluster, deleteCluster } from "../components/APIManager.js";
import { bus } from "../main.js";

export default {
  data() {
    return {
      newClusterDialog: false,
      newClusterName: "",
      search: "",
      clusters: [],
      keywords: [],
      loading: false,
      selectedItem: null,
      delete_cluster: false,
      edit_cluster: false,
      //entityIDType: "publisher_id"
    };
  },

  watch: {
    $route(to, from) {
      this.loading = true;
      let qry = JSON.parse(JSON.stringify(this.$route.query));
      this.loadClusters(qry.entity_type);
    },

    /* delete_cluster(value) {
      if (!value) {
        this.loadClusters();
      } 
    }*/
  },

  mounted() {
    this.loadClusters(this.entityType);
  },

  computed: {
    headers() {
      return [
        { text: "Cluster Name", value: "name" },
        { text: "Number of Entities", value: "entity_count" },
        { text: "Actions", value: "id" },
      ];
    },
    entityIDType() {
      let qry = JSON.parse(JSON.stringify(this.$route.query));

      return qry.entity_type + "_id";
    },

    entityType() {

      let qry = JSON.parse(JSON.stringify(this.$route.query));

      return qry.entity_type;
    },

    filteredClusters() {
      return this.clusters.filter(cluster =>
        cluster.name.toLowerCase().includes(this.search.toLowerCase())
      );
    }
  },

  methods: {

    async postCluster() {
      this.loading = true;
      addCluster(encodeURIComponent(this.newClusterName), this.entityType).then(results => {
        this.clusters = results.data;
        this.newClusterName = "";
        this.loading = false;
      });
    },

    async removeCluster(id) {
      this.loading = true;
      deleteCluster(id).then(results => {
        this.clusters = [];
        this.clusters = results.data;
        this.loading = false;
      });
    },

    async loadClusters(clusterType) {
      this.loading = true;
      getClusters(clusterType).then(results => {
        this.clusters = results.data;
        this.loading = false;
      });
    },

    clearSearch() {
      this.keywords = [];
      this.loadClusters();
    },

    remove_kw(item) {
      this.keywords.splice(this.keywords.indexOf(item), 1);
      if (this.keywords.length == 0) {
        this.clearSearch();
      }
    },

    fetchClusterData(cluster_id) {
      const qry = JSON.parse(JSON.stringify(this.$route.query));
      const entityType = qry.entity_type;
      const cluster_filter_name = entityType === "supplier" ? "supplier_cluster" : "buyer_cluster";

      this.$router.push({
        name: "search",
        query: {
          [cluster_filter_name]: [cluster_id],
          sort_order: "asc",
          viewIndex: 0
        }
      });
      bus.$emit("hide-side-navs", true);
    },
  }
};
</script>

<style scoped>
.v-application--is-ltr .v-list-group--sub-group .v-list-group__header {
  padding-left: 0px !important;
}

.wrap-text {
  -webkit-line-clamp: unset !important;
}

.tooltip {
  display: inline-block;
  max-width: 360px;
}

.border {
  border: 1px solid rgb(255, 20, 99);
}

.hvr:hover {
  text-decoration: underline !important;
}
</style>